import styled from "styled-components";
import { devices } from "@/constants/media";

export const StyledCallEnded = styled.div<{
  $height: number
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${({ $height }) => $height}px;
  background-color: var(--color-background);
`;

export const FeedbackButtons = styled.div`
  display: flex;
  gap: var(--spacing-sm);
  margin-top: var(--spacing-sm);
  button {
    flex: 1;
    white-space: nowrap;
  }
  @media ${devices.sm} {
    flex-direction: column;
  }
`;

export const FeedbackContainer = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
`;

export const FeedbackOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
`;

export const FeedbackTextArea = styled.textarea`
  resize: none;
  padding: var(--spacing-sm);
  font-size: var(--font-size-sm);
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-border);
  width: 100%;
`;